import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { fetchHoldingAccount } from "../../helper/Api";
import moment from "moment";
import { createDashboardFormatter } from "../DashboardBox/dashboardAmountUtils";

const HoldingAccountBalanceOverlay = ({
  openOverlay,
  holdingAccountBalanceOverlays,
  fetchHoldingAccountBalance,
  fy_list,
  filterPayload,
  dividerNumber = 1,
}) => {
  const { authData } = useSelector((state) => state.authData);
  const holdingDepartmentId = filterPayload?.department_id || authData?.user?.department_id || '';
  const [holdingOverlayOpen, setHoldingOverlayOpen] = useState(true);
  const storedGlobalDateId = localStorage.getItem("globalDateId");
  const [holdingAccount, setHoldingAccount] = useState(null);

  const formatNumber = createDashboardFormatter(dividerNumber);

  const openHoldingOverlay = (value) => {
    setHoldingOverlayOpen(value);
    holdingAccountBalanceOverlays(value);
  };

  useEffect(() => {
    setHoldingOverlayOpen(openOverlay);
  }, [openOverlay]);

  useEffect(() => {
    let cancelled = false;
    setHoldingAccount(null);
    const getHoldingAccount = async () => {
      try {
        const accountData = await fetchHoldingAccount(holdingDepartmentId);
        if (cancelled) return;
        if (accountData?.data?.status) {
          const result = accountData.data.result || null;
          setHoldingAccount(result);
          fetchHoldingAccountBalance(result);
        } else {
          setHoldingAccount(null);
          fetchHoldingAccountBalance(null);
        }
      } catch (err) {
        if (!cancelled) {
          setHoldingAccount(null);
          fetchHoldingAccountBalance(null);
        }
      }
    };
    getHoldingAccount();
    return () => {
      cancelled = true;
    };
  }, [storedGlobalDateId, holdingDepartmentId]);

  return (
    <div>
      <div
        className={`bank-balance-overlay ${holdingOverlayOpen ? "d-none" : null}`}
      />

      <div
        className={`bank-balance-overlay-flow overflow-x-hidden ${
          holdingOverlayOpen ? "left-100" : null
        }`}
      >
        <div className="bg-warning-100 position-relative text-white p-3 fw-600 fs-18px d-flex justify-content-between align-items-center position-sticky top-0">
          <div className="d-flex gap-1 align-items-center">
            <span>
              <i
                className="icon-close_circle_fill cursor-pointer text-white"
                onClick={() => openHoldingOverlay(true)}
              />
            </span>
            <span className="fw-500">Holding Account Balance FY</span>
            <select
              name="financial_year_id"
              className="bg-transparent border-0 text-white fw-500 fs-16px select"
              disabled
              value={
                fy_list?.find(
                  (fy) =>
                    String(fy.id) === String(storedGlobalDateId) ||
                    (!storedGlobalDateId &&
                      fy.start_year === moment().format("YYYY"))
                )?.id || ""
              }
            >
              <option value="" className="text-black">
                select year
              </option>
              {fy_list?.map((fy) => (
                <option
                  value={fy.id}
                  key={fy.id}
                  className="text-black"
                >
                  {fy.year}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="overflow-auto px-3 fs-14px m-0 h-100">
          {!holdingAccount ? (
            <div className="py-4 text-center text-black-50">
              No holding accounts found
            </div>
          ) : (
            <>
              <div className="row bg-prime-100 p-0 m-0 py-2 px-2">
                <div className="col-4 p-0 m-0 text-white fs-14px">Account</div>
                <div className="col-4 p-0 m-0 text-white fs-14px">Balance</div>
                <div className="col-4 p-0 m-0 text-white fs-14px">Interest</div>
              </div>

              <div className="row p-0 m-0 py-2 px-2 border-bottom">
                <div className="col-4 p-0 m-0 fs-14px">
                  <div>{holdingAccount?.account_name || "Holding Account"}</div>
                  <div className="fs-12px text-black-50">{holdingAccount?.account_no}</div>
                </div>
                <div className="col-4 p-0 m-0 fs-14px">
                  <div className="fw-600">
                    {formatNumber(holdingAccount?.account_balance, "indian")}
                  </div>
                  {holdingAccount?.balance_date && (
                    <div className="fs-12px fst-italic">
                      as on {holdingAccount.balance_date}
                    </div>
                  )}
                </div>
                <div className="col-4 p-0 m-0 fs-14px">
                  <div className="row">
                    {[1, 2, 3, 4].map((q) => (
                      <div className="col-6 m-0 p-0" key={q}>
                        Q{q}:{" "}
                        {holdingAccount?.quarterlyInterest?.find(
                          (item) => String(item?.quarter) === String(q)
                        )?.amount || "-"}
                      </div>
                    ))}
                  </div>
                  <div className="text-end text-success-100 fs-14px fw-500">
                    Total:{" "}
                    {holdingAccount?.quarterlyInterest?.reduce(
                      (sum, item) => sum + Number(item?.amount || 0),
                      0
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default HoldingAccountBalanceOverlay;
